import store from '@/store/index'

export const JUMP_TARGET =
  process.env.VUE_APP_DEPLOY_ENV === 'production'
    // ? 'http://jrzhfw.zjzwfw.gov.cn'
    // ? 'https://loanpc.zjfcs.org.cn'
    ? 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/reserved/index.html'
    : 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/lastTest/index.html?debug=true'

let zjzwfwLegalLoginUrl = 'https://esso.zjzwfw.gov.cn/opensso/spsaehandler/metaAlias/sp'
let loginCallBack = process.env.VUE_APP_DEPLOY_ENV === 'production'
  ? `https://loanh5.zjfcs.org.cn/api/sso/user/corporation/token`
  // ? `https://zjybj.8na8na.com/prod/api/sso/user/corporation/token`
  : `http://loanh5.zjjf.org.cn/api/sso/user/corporation/token`
export const getZjzwfwLegalLoginUrlSplice = (currentUrl) => {
  let areaId = store.state.areaId
  const areaIdParam = areaId ? `?areaId=${areaId}` : ''
  // goto 地址
  let gotoURL = currentUrl
    ? `${currentUrl}${areaIdParam}`
    : `${window.location.origin}${window.location.pathname}${areaIdParam}`
  return `${zjzwfwLegalLoginUrl}?spappurl=${loginCallBack}?goto=${gotoURL}`
}
